import * as React from 'react';
import {Switch} from 'react-router-dom';

import {EmailDigestPage} from '../../ui/email-digest/email-digest-page';
import {PageWrapper} from '../../ui/layout/page-wrapper';

import {PageRoute} from '../shared/page-route';

export function EmailDigestRoot() {
    return (
        <PageWrapper>
            <Switch>
                {/* @ts-expect-error */}
                <PageRoute exact={true} path='/email-digest' component={EmailDigestPage} />
            </Switch>
        </PageWrapper>
    );
}
